import { inject, Injectable } from '@angular/core';
import { WindowRefService } from './window-ref.service';

@Injectable({ providedIn: 'root' })
export class GoogleTagManagerService {
  private readonly windowRef = inject(WindowRefService);

  /**
   * Initializes Google Tag Manager.
   * This function should only be used to init GTM for Hoosier, Colorado and Northampton.
   *
   * @param id - The GTM or Ads ID to initialize.
   */
  init(id?: string): void {
    if (!id) return;

    try {
      if (id.startsWith('GTM-')) {
        this.initGtm(id);
      } else if (id.startsWith('AW-')) {
        this.initGoogleAds(id);
      }
    } catch (e) {
      console.log('Failed to init tag manager');
    }
  }

  private initGtm(id: string): void {
    const w = this.windowRef.nativeWindow;

    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      'gtm.start': Date.now(),
      event: 'gtm.js',
    });

    this.appendScript(`https://www.googletagmanager.com/gtm.js?id=${id}`);

    this.appendNoScriptIframe(`https://www.googletagmanager.com/ns.html?id=${id}`);
  }

  private initGoogleAds(id: string): void {
    const w = this.windowRef.nativeWindow;

    w.dataLayer = w.dataLayer || [];

    w.gtag =
      w.gtag ||
      ((...args: unknown[]) => {
        w.dataLayer?.push(args);
      });

    w.gtag('js', new Date());
    w.gtag('config', id);

    this.appendScript(`https://www.googletagmanager.com/gtag/js?id=${id}`);
  }

  private appendScript(src: string): void {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;

    document.head.appendChild(script);
  }

  private appendNoScriptIframe(src: string): void {
    const noscript = document.createElement('noscript');

    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';

    noscript.appendChild(iframe);
    document.body.appendChild(noscript);
  }
}
